import React from 'react'
import Wrapper from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleDot, faCircle } from '@fortawesome/free-regular-svg-icons'

const SchChildMenu = ({onClick, children, active}) => {

	return (
		<Wrapper
			active={active}
			onClick={onClick}
		>
			<div
				className="icon"
			>
				{active
					? <FontAwesomeIcon
						icon={faCircleDot}
						fixedWidth
					/>
					: <FontAwesomeIcon
						icon={faCircle}
						fixedWidth
					/>
				}
			</div>
			{children
				&& (
					<div className="value">{children}</div>
				)
			}
		</Wrapper>
	)
}

export default SchChildMenu
